export function stepTravelDir(fromIndex: number, toIndex: number): 1 | -1 | 0 {
  if (toIndex > fromIndex) return 1;
  if (toIndex < fromIndex) return -1;
  return 0;
}
